import { render, staticRenderFns } from "./RelatedResources.vue?vue&type=template&id=483fcb1a"
import script from "./RelatedResources.vue?vue&type=script&lang=js"
export * from "./RelatedResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/home/forge/meidenvanholland.nl/components/slider.vue').default})
